import { render, staticRenderFns } from "./SLAConfig.vue?vue&type=template&id=6378a830&scoped=true"
import script from "./SLAConfig.vue?vue&type=script&lang=js"
export * from "./SLAConfig.vue?vue&type=script&lang=js"
import style0 from "./SLAConfig.vue?vue&type=style&index=0&id=6378a830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6378a830",
  null
  
)

export default component.exports